import { IPaginationParams } from './shared.dto';

abstract class IAccountsDAO {
    public abstract getAccounts(params: IPaginationParams): Promise<IAccountListDTO>;
    public abstract getUserAccounts(params: IPaginationParams): Promise<IAccountListDTO>;
    public abstract createAccount(
        name: string,
        salesforceAccountId?: string,
        allowedProviders?: string[]
    ): Promise<IAccountDetailsDTO>;
    public abstract updateAccount(params: {
        accountId: number;
        name: string;
        subdomain?: string;
        salesforceAccountId?: string;
        allowedProviders?: string[];
    }): Promise<IAccountDetailsDTO>;
    public abstract readAccount(accountId: number): Promise<IAccountDetailsDTO>;
    public abstract getReservedSubdomains(): Promise<string[]>;
    public abstract deleteAccount(params: {accountId: number}): Promise<void>;
}

interface IAccountDetailsDTO {
    accountId: number;
    name: string;
    salesforceAccountId?: string;
    allowedProviders?: string[];
    anonymizationEnabled?: boolean;
    orderBookingEnabled?: boolean;
}

interface IAccountListDTO {
    content: IAccountDetailsDTO[];
    totalElements: number;
}

export { IAccountListDTO, IAccountsDAO, IAccountDetailsDTO };
